<template>
    <section id="buy-box-subscription-daily-rental">
        <label>{{ $t('pds.buy_box.daily_rental_info') }}</label>

        <button v-b-modal.modal-1 type="button" class="btn btn-primary btn-block mt-3">
            {{ $t('pds.buy_box.contact_us_button') }}
        </button>

        <b-modal id="modal-1" modal-class="daily-rental-typeform" hide-footer @shown="openDailyRentalTypeformPopup">
            <div id="typeform-container" :data-tf-hidden="hiddenParamterString"></div>
        </b-modal>
        
    </section>
</template>

<script>
import { BModal, VBModal } from "bootstrap-vue";
import { createWidget } from '@typeform/embed';

export default {
    name: 'BuyBoxSubscriptionDailyRental',
    components: {
        BModal, createWidget,
    },
    props: {
        entry: {
            type: Object,
            required: true
        }
    },
    directives: { 
        'b-modal': VBModal 
    },
    data() {
        return {
            showLoading: true,
            subscriptionDailyRentalTypeformLink: `https://f2zidcy3s4g.typeform.com/to/SiKillNC#vehicle_id=${this.entry.id}`
        }
    },
    methods: {
        openDailyRentalTypeformPopup() {
            createWidget(this.subscriptionDailyRentalTypeformLink, {
                container: document.querySelector('#typeform-container')
            })
        }
    },
    computed: {
        hiddenParamterString() {
            return `vehicle_id=${this.entry.id}`
        }
    }
}
</script>